import axios from 'axios';
import {
  authHeader,
  uploadAuthHeader,
  authHeader2
} from '@/utils/authHeader';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

class Request {

  constructor(url) {
    this.url = `${url}`;
  }

  // =====================================
  // POST
  // =====================================

  async post(raw, callback, useAuth = true) {

    const headers = useAuth
      ? authHeader()
      : {};

    try {

      const response = await apiClient.post(
        this.url,
        raw,
        { headers }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // POST FORM DATA
  // =====================================

  async postFormData(raw, callback, useAuth = true) {

    const headers = useAuth
      ? authHeader2()
      : { 'Content-Type': 'multipart/form-data' };

    try {

      const response = await apiClient.post(
        this.url,
        raw,
        { headers }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // PATCH
  // =====================================

  async patch(raw, callback, useAuth = true) {

    const headers = useAuth
      ? authHeader()
      : {};

    try {

      const response = await apiClient.patch(
        this.url,
        raw,
        { headers }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // PATCH FORM DATA
  // =====================================

  async patchFormData(raw, callback, useAuth = true) {

    const headers = useAuth
      ? authHeader2()
      : { 'Content-Type': 'multipart/form-data' };

    try {

      const response = await apiClient.patch(
        this.url,
        raw,
        { headers }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // PUT
  // =====================================

  async put(raw, callback, useAuth = true) {

    const headers = useAuth
      ? authHeader()
      : {};

    try {

      const response = await apiClient.put(
        this.url,
        raw,
        { headers }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // GET
  // =====================================

  async get(callback, useAuth = true) {

    const headers = useAuth
      ? authHeader()
      : {};

    try {

      const response = await apiClient.get(
        this.url,
        { headers }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // DELETE
  // =====================================

  async delete(callback, bodyData = {}, useAuth = true) {

    const headers = useAuth
      ? authHeader()
      : {};

    try {

      const response = await apiClient.delete(
        this.url,
        {
          headers,
          data: bodyData
        }
      );

      callback(response.data, undefined);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse);
    }
  }

  // =====================================
  // UPLOAD
  // =====================================

  async upload(raw, callback, params = null, useAuth = true) {

    const headers = useAuth
      ? uploadAuthHeader()
      : {};

    try {

      const response = await apiClient.post(
        this.url,
        raw,
        { headers }
      );

      callback(response.data, undefined, params);

    } catch (err) {

      const errorResponse = err.response
        ? err.response.data
        : { message: err.message };

      callback(undefined, errorResponse, params);
    }
  }
}

export default Request;